export default __webpack_public_path__ + "1c079d3d174d832f44b5ac6cc41212fe.svg";